import isEmpty from "lodash/isEmpty";

const isNumber = (v) => typeof v === 'number';
const isString = (v) => typeof v === 'string';
const isNullOrUndefined = (v) => v == undefined;
const isArray = (v) => Array.isArray(v);
const isObject = (v) => typeof v === 'object';
const isEmptyString = (v) => isString(v) && v.trim().length === 0;
const isEmptyArrayOrObject = (v) => (isArray(v) || isObject(v)) && isEmpty(v);

const compareStringAndNumber = (oldValue, newValue) => {
  if ((isNumber(oldValue) && isString(newValue)) || (isNumber(newValue) && isString(oldValue))) {
    // e.g. oldValue = 1 and newValue = "1"
    return oldValue == newValue;
  }
  return undefined;
}

const compareEmptyString = (oldValue, newValue) => {
  if (oldValue == null && isEmptyString(newValue)) {
    // e.g. oldValue = null and newValue = ""
    return true;
  }
  return undefined;
}

export { isNumber, isString, isEmptyString, isNullOrUndefined, isArray, isObject, isEmptyArrayOrObject, compareStringAndNumber, compareEmptyString };
